// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rpt {
  box-sizing: border-box;
  min-height: 100%;
  padding: 20px 24px 28px;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #0f172a;
}

.rpt-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.rpt-header__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.rpt-crumb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.rpt-crumb .is-current {
  color: #0f172a;
  font-weight: 600;
}

.rpt-switch {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.rpt-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: #0f172a;
}

.rpt-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
}

.rpt-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.rpt-tab {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
}

.rpt-tab:hover {
  background: #f8fafc;
  color: #0f172a;
}

.rpt-tab.is-active {
  border-color: #bae6fd;
  background: #e0f2fe;
  color: #0284c7;
  font-weight: 600;
}

.rpt-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.rpt-kpi {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rpt-kpi__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.rpt-kpi__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0284c7;
  flex-shrink: 0;
}

.rpt-kpi__note {
  font-size: 12px;
  color: #64748b;
}

.rpt-kpi__label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.rpt-kpi__value {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}

.rpt-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.rpt-split {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(240px, 1fr);
  gap: 12px;
}

.rpt-card {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rpt-card__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 14px 16px 0;
}

.rpt-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.rpt-card__hint {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.rpt-bars {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 16px;
}

.rpt-bar {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.rpt-bar__label,
.rpt-bar__value {
  font-size: 12px;
  color: #475569;
  font-variant-numeric: tabular-nums;
}

.rpt-bar__value {
  color: #0f172a;
  font-weight: 600;
}

.rpt-bar__track {
  height: 8px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.rpt-bar__fill {
  height: 100%;
  border-radius: inherit;
  background: #0ea5e9;
}

.rpt-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.rpt-toolbar__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rpt-search {
  width: min(320px, 100%);
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 13px;
  font-family: inherit;
}

.rpt-search:focus {
  outline: none;
  border-color: #0ea5e9;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.rpt-count {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.rpt-table-wrap {
  overflow-x: auto;
}

.rpt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.rpt-table th {
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  text-align: start;
  white-space: nowrap;
}

.rpt-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  color: #0f172a;
  vertical-align: middle;
}

.rpt-table tr:last-child td {
  border-bottom: 0;
}

.rpt-table .is-end {
  text-align: end;
}

.rpt-name {
  font-weight: 600;
}

.rpt-muted {
  color: #64748b;
}

.rpt-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.rpt-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 12px;
  font-weight: 600;
}

.rpt-list {
  display: flex;
  flex-direction: column;
}

.rpt-list__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
}

.rpt-list__row:first-child {
  border-top: 0;
}

.rpt-list__meta {
  font-size: 12px;
  color: #64748b;
}

.rpt-columns {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 240px;
  padding: 8px 16px 16px;
  overflow-x: auto;
}

.rpt-column {
  flex: 1 0 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-width: 64px;
}

.rpt-column__value {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #0284c7;
  font-variant-numeric: tabular-nums;
}

.rpt-column__plot {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.rpt-column__fill {
  width: 28px;
  border-radius: 6px 6px 2px 2px;
  background: #0ea5e9;
}

.rpt-column__name {
  margin-top: 8px;
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  color: #64748b;
  text-align: center;
}

.rpt-meter {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
}

.rpt-meter__track {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.rpt-meter__fill {
  height: 100%;
  border-radius: inherit;
  background: #0ea5e9;
}

.rpt-meter span {
  min-width: 42px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  font-variant-numeric: tabular-nums;
  text-align: end;
}

.rpt-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #64748b;
}

.rpt-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rpt-pager__btn {
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}

.rpt-pager__btn:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.rpt-pager__page {
  min-width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #0ea5e9;
  color: #ffffff;
  font-weight: 700;
}

.rpt-link {
  color: #0f172a;
  font-weight: 600;
  text-decoration: none;
}

.rpt-link:hover {
  color: #0284c7;
}

.rpt-empty,
.rpt-loading {
  padding: 28px 16px;
  text-align: center;
  color: #64748b;
  font-size: 13px;
}

@media (max-width: 900px) {
  .rpt-header,
  .rpt-toolbar {
    flex-direction: column;
  }

  .rpt-kpis,
  .rpt-grid,
  .rpt-split {
    grid-template-columns: 1fr;
  }

  .rpt-bar {
    grid-template-columns: 72px minmax(0, 1fr) auto;
  }
}

.clinical-main:has(.ovw),
.clinical-main__scroll:has(.ovw),
.clinical-main:has(.yld),
.clinical-main__scroll:has(.yld) {
  background: #f8fafc;
}

.ovw,
.yld {
  box-sizing: border-box;
  min-height: 100%;
  background: #f8fafc;
  color: #0f172a;
}

.ovw-body,
.yld-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
}

.ovw {
  display: flex;
  flex-direction: column;
}

.ovw * {
  box-sizing: border-box;
}

.ovw-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.ovw-crumb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.ovw-crumb .is-current {
  color: #0f172a;
  font-weight: 600;
}

.ovw-title {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.ovw-subtitle {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.ovw-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.ovw-switch {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 3px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  gap: 2px;
}

.ovw-switch a {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.ovw-switch a.is-active {
  background: #ffffff;
  color: #0284c7;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.ovw-select,
.ovw-export,
.ovw-search {
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
}

.ovw-select {
  padding: 0 28px 0 12px;
  max-width: 180px;
}

.ovw-range.ant-picker {
  height: 36px;
  border-radius: 8px;
  border-color: #e2e8f0;
}

.ovw-export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  cursor: pointer;
}

.ovw-export:hover,
.ovw-select:hover,
.ovw-search:hover {
  border-color: #cbd5e1;
}

.ovw-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.ovw-kpi,
.ovw-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.ovw-kpi {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0;
  padding: 20px;
  border-radius: 6px;
}

.ovw-kpi__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.ovw-kpi__label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ovw-kpi__icon {
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.ovw-kpi__value {
  font-size: 26px;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.ovw-kpi__value span {
  margin-left: 4px;
  color: #64748b;
  font-size: 14px;
  font-weight: 400;
}

.ovw-kpi__foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
}

.ovw-kpi__foot .is-up {
  color: #059669;
  font-weight: 600;
}

.ovw-kpi__foot .is-down {
  color: #e11d48;
  font-weight: 600;
}

.ovw-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #ecfdf5;
  color: #10b981;
  font-size: 11px;
  font-weight: 600;
}

.ovw-pill.is-down {
  background: #fff1f2;
  color: #e11d48;
}

.ovw-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
}

.ovw-chip svg {
  color: #94a3b8;
}

.ovw-bullet {
  color: #cbd5e1;
  font-size: 11px;
  line-height: 1;
}

.ovw-amount {
  color: #1e293b;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.ovw-redemption {
  color: #0284c7;
  font-weight: 600;
}

.ovw-card__bar,
.ovw-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
}

.ovw-card__bar {
  border-bottom: 1px solid #e2e8f0;
}

.ovw-card__head .ovw-pill {
  flex-shrink: 0;
  align-self: flex-start;
  white-space: nowrap;
}

.ovw-card h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.ovw-card p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
}

.ovw-search {
  min-width: 180px;
  padding: 0 12px;
}

.ovw-table-wrap {
  overflow-x: auto;
}

.ovw-table {
  width: 100%;
  border-collapse: collapse;
}

.ovw-table th {
  padding: 10px 16px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: start;
  border-bottom: 1px solid #e2e8f0;
}

.ovw-table td {
  padding: 14px 16px;
  font-size: 13px;
  border-bottom: 1px solid #f1f5f9;
}

.ovw-table th.is-end,
.ovw-table td.is-end {
  text-align: end;
}

.ovw-name {
  font-weight: 600;
}

.ovw-muted {
  color: #64748b;
  text-align: center;
}

.ovw-meter {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
}

.ovw-meter__track,
.ovw-mix__track {
  flex: 1;
  height: 8px;
  border-radius: 99px;
  background: #f1f5f9;
  overflow: hidden;
}

.ovw-meter__fill,
.ovw-mix__track div {
  height: 100%;
  border-radius: 99px;
  background: #0ea5e9;
}

.ovw-meter span,
.ovw-mix__row strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.ovw-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  color: #64748b;
  font-size: 12px;
}

.ovw-pager div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ovw-pager button,
.ovw-pager__page {
  height: 32px;
  min-width: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.ovw-pager button:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.ovw-pager__page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0ea5e9;
  border-color: #0ea5e9;
  color: #ffffff;
}

.ovw-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.ovw-mix {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 20px 20px;
}

.ovw-mix__row {
  display: grid;
  grid-template-columns: minmax(90px, 140px) minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  color: #334155;
  font-size: 13px;
}

.pkg-pie-card {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 4px 20px 20px;
}

.pkg-donut-wrap {
  position: relative;
  width: 196px;
  height: 196px;
  flex-shrink: 0;
}

.pkg-donut {
  display: block;
  transform: rotate(-90deg);
}

.pkg-donut-center {
  position: absolute;
  inset: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
}

.pkg-donut-center span {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.pkg-donut-center strong {
  color: #0f172a;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.clinical-main:has(.ptn),
.clinical-main__scroll:has(.ptn) {
  background: #f1f5f9;
}

.ptn {
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: #ffffff;
  color: #0f172a;
}

.ptn * {
  box-sizing: border-box;
}

.ptn-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.ptn-crumb {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.ptn-crumb .is-current {
  color: #0f172a;
}

.ptn-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.ptn-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 30px;
}

.ptn-header p {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 18px;
}

.ptn-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.ptn-switch a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.ptn-switch a:hover {
  color: #0f172a;
}

.ptn-switch a.is-active {
  background: #e0f2fe;
  color: #0284c7;
  font-weight: 600;
}

.ptn-switch__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #0284c7;
}

.ptn-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ptn-filters__start {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.ptn-range-wrap,
.ptn-select-wrap,
.ptn-search {
  position: relative;
  display: flex;
  align-items: center;
}

.ptn-range-wrap > svg,
.ptn-select-wrap > svg:first-child,
.ptn-search > svg {
  position: absolute;
  color: #64748b;
  pointer-events: none;
}

.ptn-range-wrap > svg,
.ptn-select-wrap > svg:first-child {
  left: 12px;
  z-index: 1;
}

.ptn-select-wrap > svg:last-child {
  position: absolute;
  right: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.ptn-select,
.ptn-export,
.ptn-search input {
  height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-family: inherit;
  font-weight: 500;
}

.ptn-select {
  min-width: 180px;
  padding: 0 32px;
  appearance: none;
  cursor: pointer;
}

.ptn-export {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  cursor: pointer;
}

.ptn-export svg {
  color: #64748b;
}

.ptn-export:hover,
.ptn-select:hover,
.ptn-search input:hover {
  background: #f8fafc;
}

.ptn-range.ant-picker {
  height: 36px;
  padding-inline-start: 34px;
  border-radius: 8px;
  border-color: #cbd5e1;
}

.ptn-range .ant-picker-input > input {
  font-size: 13px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.ptn-range .ant-picker-suffix {
  color: #94a3b8;
}

.ptn-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.ptn-kpi,
.ptn-card {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}

.ptn-kpi {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px;
}

.ptn-kpi__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin-bottom: 2px;
}

.ptn-kpi__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #e0f2fe;
  color: #0284c7;
}

.ptn-kpi__label {
  color: #64748b;
  font-family: 'Public Sans', 'Inter', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ptn-kpi strong {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 30px;
  font-variant-numeric: tabular-nums;
}

.ptn-kpi p,
.ptn-card p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 16px;
}

.ptn-kpi p {
  font-variant-numeric: tabular-nums;
}

.ptn-split {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(260px, 1fr);
  gap: 24px;
}

.ptn-card {
  min-width: 0;
  padding: 20px;
}

.ptn-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.ptn-card h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.005em;
  line-height: 22px;
}

.ptn-search > svg {
  left: 10px;
}

.ptn-search input {
  width: 192px;
  padding: 0 12px 0 32px;
}

.ptn-search input:focus,
.ptn-select:focus,
.ptn-range.ant-picker-focused {
  border-color: #0ea5e9;
  outline: none;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

.ptn-table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ptn-table {
  width: 100%;
  border-collapse: collapse;
}

.ptn-table th {
  padding: 10px 14px;
  background: #f8fafc;
  color: #64748b;
  font-family: 'Public Sans', 'Inter', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  border-bottom: 1px solid #e2e8f0;
}

.ptn-table td {
  padding: 14px;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;
}

.ptn-table tr:last-child td {
  border-bottom: 0;
}

.ptn-table tbody tr:hover td {
  background: #f8fafc;
}

.ptn-table th.is-end,
.ptn-table td.is-end {
  text-align: end;
}

.ptn-name {
  color: #0f172a;
  font-weight: 500;
}

.ptn-num,
.ptn-money {
  color: #334155;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.ptn-money {
  color: #0f172a;
  font-weight: 600;
}

.ptn-money.is-neg {
  color: #dc2626;
}

.ptn-empty {
  color: #64748b;
  text-align: center;
}

.ptn-birthdays {
  display: flex;
  flex-direction: column;
}

.ptn-birthdays > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #e2e8f0;
}

.ptn-birthdays > div:first-child {
  padding-top: 0;
}

.ptn-birthdays > div:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.ptn-birthdays strong {
  display: block;
  color: #0f172a;
  font-size: 14px;
  font-weight: 500;
}

.ptn-birthdays em {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  font-variant-numeric: tabular-nums;
}

.ptn-birthdays b {
  flex-shrink: 0;
  padding: 4px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.ptn-loading {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

@media (max-width: 1100px) {
  .ptn-header__top,
  .ptn-kpis,
  .ptn-split {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .ptn-kpis {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .ptn-switch {
    align-self: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 720px) {
  .ptn {
    padding: 16px;
  }

  .ptn-kpis,
  .ptn-card__head,
  .ptn-filters {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .ptn-search input,
  .ptn-select {
    width: 100%;
  }
}

.pkg-pie-empty {
  padding: 4px 20px 20px;
}

.pkg-pie-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.pkg-pie-legend > div {
  display: grid;
  grid-template-columns: 12px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
}

.pkg-pie-legend > div:last-child {
  border-bottom: 0;
}

.pkg-pie-legend i {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.pkg-pie-legend span {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.pkg-pie-legend strong {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  color: #0f172a;
  font-size: 13px;
}

.pkg-pie-legend em {
  color: #64748b;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
}

@media (max-width: 720px) {
  .pkg-pie-card {
    flex-direction: column;
    align-items: flex-start;
  }
}

.ovw-loading {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

@media (max-width: 1100px) {
  .ovw-header {
    flex-direction: column;
    align-items: stretch;
  }

  .ovw-controls {
    justify-content: flex-start;
  }

  .ovw-kpis,
  .ovw-split {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .ovw-kpis,
  .ovw-split,
  .ovw-card__bar {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
}

.clinical-main:has(.wrk),
.clinical-main__scroll:has(.wrk) {
  background: #f8fafc;
}

.wrk {
  box-sizing: border-box;
  min-height: 100%;
  background: #f8fafc;
  color: #0f172a;
}

.wrk-body {
  padding: 24px;
}

.wrk * {
  box-sizing: border-box;
}

.wrk-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
}

.wrk-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.wrk-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.wrk-header p,
.wrk-card p,
.wrk-table-card__head p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.wrk-switch {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f1f5f9;
}

.wrk-switch a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

.wrk-switch a.is-active {
  background: #ffffff;
  color: #0284c7;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.wrk-switch__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #0ea5e9;
}

.wrk-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 4px;
}

.wrk-filters__start {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.wrk-range-wrap,
.wrk-select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.wrk-range-wrap > svg,
.wrk-select-wrap > svg {
  position: absolute;
  color: #94a3b8;
  pointer-events: none;
}

.wrk-range-wrap > svg {
  left: 10px;
  z-index: 1;
}

.wrk-select-wrap > svg {
  right: 10px;
}

.wrk-select,
.wrk-export,
.wrk-search {
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-family: inherit;
}

.wrk-table-tools .wrk-select {
  padding: 0 10px;
}

.wrk-select-wrap .wrk-select {
  min-width: 220px;
  padding: 0 32px 0 12px;
  appearance: none;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  cursor: pointer;
}

.wrk-export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  color: #334155;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  cursor: pointer;
}

.wrk-export svg {
  color: #64748b;
}

.wrk-range.ant-picker {
  height: 36px;
  padding-inline-start: 32px;
  border-radius: 8px;
  border-color: #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.wrk-range .ant-picker-input > input {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  font-weight: 500;
}

.wrk-range .ant-picker-suffix {
  color: #94a3b8;
}

.wrk-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.wrk-kpi,
.wrk-card,
.wrk-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.wrk-kpi {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 148px;
  padding: 20px;
}

.wrk-kpi__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wrk-kpi p {
  margin: 0;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.wrk-kpi strong {
  display: block;
  margin-top: 4px;
  font-size: 26px;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.wrk-kpi strong span {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 400;
}

.wrk-kpi__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid transparent;
}

.wrk-kpi__icon.is-sky {
  background: #f0f9ff;
  color: #0ea5e9;
  border-color: #e0f2fe;
}

.wrk-kpi__icon.is-green {
  background: #ecfdf5;
  color: #059669;
  border-color: #d1fae5;
}

.wrk-kpi__icon.is-indigo {
  background: #eef2ff;
  color: #4f46e5;
  border-color: #e0e7ff;
}

.wrk-kpi__icon.is-amber {
  background: #fffbeb;
  color: #d97706;
  border-color: #fef3c7;
}

.wrk-kpi__foot {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.wrk-kpi__foot .is-up {
  color: #047857;
}

.wrk-kpi__foot .is-down {
  color: #be123c;
}

.wrk-split {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.wrk-card,
.wrk-table-card__head {
  padding: 20px;
}

.wrk-card__head,
.wrk-table-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.wrk-card h2,
.wrk-table-card h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.wrk-legend {
  display: flex;
  gap: 12px;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
}

.wrk-legend span,
.wrk-legend i {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.wrk-legend i,
.wrk-bar__pair span {
  width: 10px;
  border-radius: 2px;
}

.wrk-legend i {
  height: 10px;
}

.wrk-legend i.is-scheduled,
.wrk-bar__pair .is-scheduled {
  background: #e2e8f0;
}

.wrk-legend i.is-completed,
.wrk-bar__pair .is-completed {
  background: #0ea5e9;
}

.wrk-bars {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 220px;
  margin-top: 20px;
  padding-top: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.wrk-bar {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  height: 100%;
}

.wrk-bar__ratio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-bottom: 6px;
  font-size: 10px;
  font-style: normal;
  font-variant-numeric: tabular-nums;
  text-align: center;
  line-height: 1.2;
}

.wrk-bar__ratio .is-completed {
  color: #0284c7;
  font-weight: 600;
}

.wrk-bar__ratio .is-scheduled {
  color: #64748b;
}

.wrk-bar__pair {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: 160px;
}

.wrk-bar__pair span {
  width: 16px;
  min-height: 0;
  border-radius: 3px 3px 0 0;
}

.wrk-bar strong,
.wrk-bar em {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wrk-bar strong {
  margin-top: 8px;
  font-size: 11px;
}

.wrk-bar em {
  color: #94a3b8;
  font-size: 10px;
  font-style: normal;
}

.wrk-durations {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 18px;
}

.wrk-duration__label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 12px;
}

.wrk-duration__track {
  height: 8px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.wrk-duration__track span {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: #0ea5e9;
}

.wrk-search {
  width: 220px;
  padding: 0 12px;
}

.wrk-table-tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.wrk-chart-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.wrk-chart-foot span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.wrk-chart-foot svg {
  color: #059669;
}

.wrk-table-card__head {
  border-bottom: 1px solid #e2e8f0;
}

.wrk-table-wrap {
  overflow-x: auto;
}

.wrk-table {
  width: 100%;
  border-collapse: collapse;
}

.wrk-table th {
  padding: 10px 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  border-bottom: 1px solid #e2e8f0;
}

.wrk-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
  vertical-align: middle;
}

.wrk-table th.is-end,
.wrk-table td.is-end {
  text-align: end;
}

.wrk-doctor,
.wrk-spec {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.wrk-doctor {
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.wrk-doctor > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  border: 1px solid #bae6fd;
  font-size: 12px;
  font-weight: 700;
}

.wrk-doctor strong,
.wrk-spec strong {
  font-weight: 600;
}

.wrk-clinics {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.wrk-clinics span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f0f9ff;
  color: #0369a1;
  font-size: 11px;
  font-weight: 600;
}

.wrk-clinics i {
  color: #0f172a;
  font-style: normal;
  font-variant-numeric: tabular-nums;
}

.wrk-doctor em,
.wrk-spec em,
.wrk-of {
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
}

.wrk-count {
  color: #047857;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.wrk-load {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wrk-load div {
  flex: 1;
  height: 8px;
  border-radius: 999px;
  background: #f1f5f9;
  overflow: hidden;
}

.wrk-load span {
  display: block;
  height: 100%;
  background: #10b981;
}

.wrk-load em {
  width: 40px;
  font-style: normal;
  font-size: 11px;
  font-weight: 600;
  text-align: end;
}

.wrk-table a {
  color: #0284c7;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}

.wrk-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  color: #64748b;
  font-size: 12px;
}

.wrk-pager div {
  display: flex;
  gap: 8px;
}

.wrk-pager button {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  cursor: pointer;
}

.wrk-pager button:disabled {
  color: #94a3b8;
  cursor: default;
}

.wrk-insights {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}

.wrk-insight {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.wrk-insight__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.wrk-insight h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.wrk-insight__head p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
}

.wrk-logged {
  padding: 2px 8px;
  border: 1px solid #a7f3d0;
  border-radius: 4px;
  background: #ecfdf5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.wrk-insight__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e0f2fe;
  border-radius: 999px;
  background: #f0f9ff;
  color: #0ea5e9;
}

.wrk-mix {
  margin-top: 20px;
}

.wrk-mix__bar {
  display: flex;
  height: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f5f9;
}

.wrk-mix__bar span,
.wrk-mix__cells i {
  display: block;
}

.wrk-mix__bar .is-finished,
.wrk-mix__cells .is-finished {
  background: #0ea5e9;
}

.wrk-mix__bar .is-open,
.wrk-mix__cells .is-open {
  background: #6366f1;
}

.wrk-mix__bar .is-missed,
.wrk-mix__cells .is-missed {
  background: #10b981;
}

.wrk-mix__cells {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.wrk-mix__cells > div {
  padding: 10px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  background: #f8fafc;
}

.wrk-mix__cells span {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
}

.wrk-mix__cells i {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.wrk-mix__cells strong {
  display: block;
  margin-top: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 14px;
}

.wrk-mix__cells em {
  color: #94a3b8;
  font-size: 10px;
  font-style: normal;
}

.wrk-timing {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 16px 0;
}

.wrk-timing > div {
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  text-align: center;
}

.wrk-timing span {
  display: block;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.wrk-timing strong {
  display: block;
  margin-top: 2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 17px;
}

.wrk-timing em {
  color: #059669;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
}

.wrk-notes {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wrk-notes > div {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  background: #f8fafc;
}

.wrk-notes svg {
  flex: none;
  color: #0ea5e9;
}

.wrk-notes p {
  margin: 0;
  color: #1e293b;
  font-size: 12px;
}

.wrk-insight__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 11px;
}

.wrk-insight__foot a {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #0284c7;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
}

.wrk-insight__foot a svg {
  transform: rotate(-90deg);
}

.wrk-empty,
.wrk-loading {
  padding: 28px 16px;
  color: #64748b;
  text-align: center;
}

@media (max-width: 1100px) {
  .wrk-kpis,
  .wrk-split,
  .wrk-insights,
  .wrk-header__top {
    grid-template-columns: 1fr 1fr;
    flex-direction: column;
  }
}

@media (max-width: 720px) {
  .wrk-kpis,
  .wrk-split,
  .wrk-insights,
  .wrk-mix__cells,
  .wrk-timing {
    grid-template-columns: 1fr;
  }
}

.yld-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.yld-kpi,
.yld-card,
.yld-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.yld-kpi {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 148px;
  padding: 20px;
}

.yld-kpi__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.yld-kpi p {
  margin: 0;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.yld-kpi strong {
  display: block;
  margin-top: 4px;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.yld-kpi__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid transparent;
}

.yld-kpi__icon.is-sky {
  background: #f0f9ff;
  color: #0ea5e9;
  border-color: #e0f2fe;
}

.yld-kpi__icon.is-indigo {
  background: #eef2ff;
  color: #4f46e5;
  border-color: #e0e7ff;
}

.yld-kpi__icon.is-green {
  background: #ecfdf5;
  color: #059669;
  border-color: #d1fae5;
}

.yld-kpi__icon.is-amber {
  background: #fffbeb;
  color: #d97706;
  border-color: #fef3c7;
}

.yld-kpi__foot {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.yld-kpi__foot .is-up,
.yld-kpi__foot .is-down {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.yld-kpi__foot .is-up {
  color: #047857;
}

.yld-kpi__foot .is-down {
  color: #be123c;
}

.yld-split {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;
}

.yld-card,
.yld-table-card__head {
  padding: 20px;
}

.yld-card h2,
.yld-table-card h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.yld-card p,
.yld-table-card__head p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 13px;
}

.yld-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-top: 14px;
  color: #475569;
  font-size: 11px;
}

.yld-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.yld-legend i,
.yld-share__label i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.yld-legend .is-line::before {
  content: '';
  width: 14px;
  height: 2px;
  background: #0f172a;
}

.yld-plot {
  position: relative;
  margin-top: 12px;
  margin-bottom: 28px;
}

.yld-plot .yld-stack {
  position: relative;
  height: 170px;
  margin-top: 0;
  border-bottom: 0;
}

.yld-plot .yld-stack__col {
  position: relative;
  height: 170px;
}

.yld-plot .yld-stack__col strong {
  position: absolute;
  bottom: -22px;
  margin: 0;
}

.yld-line {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 170px;
  width: 100%;
  pointer-events: none;
}

.yld-chart-foot {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.yld-share__label span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.yld-lead {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.yld-lead i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
}

.yld-bottom {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
}

.yld-machines {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}

.yld-machines > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  background: #f8fafc;
}

.yld-machines strong,
.yld-machines em {
  display: block;
}

.yld-machines em {
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
}

.yld-machines > div > span {
  color: #0284c7;
  font-size: 16px;
  font-weight: 700;
  text-align: end;
}

.yld-machines small {
  display: block;
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
}

.yld-stack {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 220px;
  margin-top: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.yld-stack__col {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  height: 100%;
}

.yld-stack__bar {
  display: flex;
  flex-direction: column-reverse;
  width: 36px;
  height: 170px;
}

.yld-stack__bar span {
  display: block;
  width: 100%;
  min-height: 2px;
}

.yld-stack__col strong {
  margin: 8px 0;
  font-size: 11px;
  font-weight: 600;
}

.yld-shares {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 16px;
}

.yld-share__label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 12px;
}

.yld-share__track,
.yld-orders__bar {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f5f9;
}

.yld-share__track span,
.yld-orders__bar span {
  display: block;
  height: 100%;
}

.yld-orders__bar {
  display: flex;
  height: 12px;
  margin-top: 16px;
}

.yld-orders__cells {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.yld-orders__cells > div {
  padding: 10px;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  background: #f8fafc;
}

.yld-orders__cells span {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 11px;
}

.yld-orders__cells strong {
  display: block;
  margin-top: 4px;
  font-size: 14px;
}

.yld-orders__cells em {
  color: #94a3b8;
  font-size: 10px;
  font-style: normal;
}

.yld-table-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.yld-search {
  width: 220px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  font-family: inherit;
}

.yld-table-wrap {
  overflow-x: auto;
}

.yld-table {
  width: 100%;
  border-collapse: collapse;
}

.yld-table th {
  padding: 10px 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  border-bottom: 1px solid #e2e8f0;
}

.yld-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.yld-table tfoot td {
  background: #f8fafc;
  font-weight: 700;
}

.yld-table th.is-end,
.yld-table td.is-end {
  text-align: end;
}

.yld-name {
  font-weight: 600;
}

.yld-meter {
  display: flex;
  align-items: center;
  gap: 8px;
}

.yld-meter div {
  flex: 1;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #f1f5f9;
}

.yld-meter span {
  display: block;
  height: 100%;
  background: #0ea5e9;
}

.yld-meter span.is-green {
  background: #10b981;
}

.yld-meter em {
  width: 48px;
  font-style: normal;
  font-size: 11px;
  font-weight: 600;
  text-align: end;
}

.yld-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  color: #64748b;
  font-size: 12px;
}

.yld-pager div {
  display: flex;
  gap: 8px;
}

.yld-pager button {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  cursor: pointer;
}

.yld-pager button:disabled {
  color: #94a3b8;
  cursor: default;
}

.yld-empty,
.yld-loading {
  padding: 28px 16px;
  color: #64748b;
  text-align: center;
}

@media (max-width: 1100px) {
  .yld-kpis,
  .yld-split,
  .yld-bottom {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .yld-kpis,
  .yld-split,
  .yld-bottom {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Reports/boards/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,MAAM;EACN,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;EAGE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;;;IAGE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,8BAA8B;EAChC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;;;IAIE,8BAA8B;IAC9B,sBAAsB;EACxB;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;;IAGE,8BAA8B;EAChC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF","sourcesContent":[".rpt {\n  box-sizing: border-box;\n  min-height: 100%;\n  padding: 20px 24px 28px;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: #0f172a;\n}\n\n.rpt-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.rpt-header__text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.rpt-crumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.rpt-crumb .is-current {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.rpt-switch {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.rpt-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: #0f172a;\n}\n\n.rpt-subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.rpt-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.rpt-tab {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.rpt-tab:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.rpt-tab.is-active {\n  border-color: #bae6fd;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-weight: 600;\n}\n\n.rpt-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.rpt-kpi {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rpt-kpi__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.rpt-kpi__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #e0f2fe;\n  color: #0284c7;\n  flex-shrink: 0;\n}\n\n.rpt-kpi__note {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.rpt-kpi__label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.rpt-kpi__value {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n  color: #0f172a;\n}\n\n.rpt-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.rpt-split {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(240px, 1fr);\n  gap: 12px;\n}\n\n.rpt-card {\n  min-width: 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rpt-card__head {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 14px 16px 0;\n}\n\n.rpt-card__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.rpt-card__hint {\n  margin: 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.rpt-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px 16px;\n}\n\n.rpt-bar {\n  display: grid;\n  grid-template-columns: 88px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n}\n\n.rpt-bar__label,\n.rpt-bar__value {\n  font-size: 12px;\n  color: #475569;\n  font-variant-numeric: tabular-nums;\n}\n\n.rpt-bar__value {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.rpt-bar__track {\n  height: 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.rpt-bar__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: #0ea5e9;\n}\n\n.rpt-toolbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.rpt-toolbar__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rpt-search {\n  width: min(320px, 100%);\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.rpt-search:focus {\n  outline: none;\n  border-color: #0ea5e9;\n  background: #ffffff;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.rpt-count {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.rpt-table-wrap {\n  overflow-x: auto;\n}\n\n.rpt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.rpt-table th {\n  padding: 10px 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n  text-align: start;\n  white-space: nowrap;\n}\n\n.rpt-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #0f172a;\n  vertical-align: middle;\n}\n\n.rpt-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.rpt-table .is-end {\n  text-align: end;\n}\n\n.rpt-name {\n  font-weight: 600;\n}\n\n.rpt-muted {\n  color: #64748b;\n}\n\n.rpt-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.rpt-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.rpt-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.rpt-list__row {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 12px 16px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.rpt-list__row:first-child {\n  border-top: 0;\n}\n\n.rpt-list__meta {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.rpt-columns {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  height: 240px;\n  padding: 8px 16px 16px;\n  overflow-x: auto;\n}\n\n.rpt-column {\n  flex: 1 0 64px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  min-width: 64px;\n}\n\n.rpt-column__value {\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #0284c7;\n  font-variant-numeric: tabular-nums;\n}\n\n.rpt-column__plot {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.rpt-column__fill {\n  width: 28px;\n  border-radius: 6px 6px 2px 2px;\n  background: #0ea5e9;\n}\n\n.rpt-column__name {\n  margin-top: 8px;\n  max-width: 72px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  color: #64748b;\n  text-align: center;\n}\n\n.rpt-meter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 140px;\n}\n\n.rpt-meter__track {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.rpt-meter__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: #0ea5e9;\n}\n\n.rpt-meter span {\n  min-width: 42px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n  font-variant-numeric: tabular-nums;\n  text-align: end;\n}\n\n.rpt-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid #e2e8f0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.rpt-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rpt-pager__btn {\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.rpt-pager__btn:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.rpt-pager__page {\n  min-width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.rpt-link {\n  color: #0f172a;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.rpt-link:hover {\n  color: #0284c7;\n}\n\n.rpt-empty,\n.rpt-loading {\n  padding: 28px 16px;\n  text-align: center;\n  color: #64748b;\n  font-size: 13px;\n}\n\n@media (max-width: 900px) {\n  .rpt-header,\n  .rpt-toolbar {\n    flex-direction: column;\n  }\n\n  .rpt-kpis,\n  .rpt-grid,\n  .rpt-split {\n    grid-template-columns: 1fr;\n  }\n\n  .rpt-bar {\n    grid-template-columns: 72px minmax(0, 1fr) auto;\n  }\n}\n\n.clinical-main:has(.ovw),\n.clinical-main__scroll:has(.ovw),\n.clinical-main:has(.yld),\n.clinical-main__scroll:has(.yld) {\n  background: #f8fafc;\n}\n\n.ovw,\n.yld {\n  box-sizing: border-box;\n  min-height: 100%;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.ovw-body,\n.yld-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 24px;\n}\n\n.ovw {\n  display: flex;\n  flex-direction: column;\n}\n\n.ovw * {\n  box-sizing: border-box;\n}\n\n.ovw-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.ovw-crumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 6px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.ovw-crumb .is-current {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.ovw-title {\n  margin: 0;\n  font-size: 22px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.ovw-subtitle {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.ovw-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.ovw-switch {\n  display: inline-flex;\n  align-items: center;\n  height: 36px;\n  padding: 3px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  gap: 2px;\n}\n\n.ovw-switch a {\n  display: inline-flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 6px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.ovw-switch a.is-active {\n  background: #ffffff;\n  color: #0284c7;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.ovw-select,\n.ovw-export,\n.ovw-search {\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.ovw-select {\n  padding: 0 28px 0 12px;\n  max-width: 180px;\n}\n\n.ovw-range.ant-picker {\n  height: 36px;\n  border-radius: 8px;\n  border-color: #e2e8f0;\n}\n\n.ovw-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  cursor: pointer;\n}\n\n.ovw-export:hover,\n.ovw-select:hover,\n.ovw-search:hover {\n  border-color: #cbd5e1;\n}\n\n.ovw-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.ovw-kpi,\n.ovw-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.ovw-kpi {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 0;\n  padding: 20px;\n  border-radius: 6px;\n}\n\n.ovw-kpi__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.ovw-kpi__label {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ovw-kpi__icon {\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.ovw-kpi__value {\n  font-size: 26px;\n  line-height: 1.15;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  font-variant-numeric: tabular-nums;\n}\n\n.ovw-kpi__value span {\n  margin-left: 4px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.ovw-kpi__foot {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.ovw-kpi__foot .is-up {\n  color: #059669;\n  font-weight: 600;\n}\n\n.ovw-kpi__foot .is-down {\n  color: #e11d48;\n  font-weight: 600;\n}\n\n.ovw-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #ecfdf5;\n  color: #10b981;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ovw-pill.is-down {\n  background: #fff1f2;\n  color: #e11d48;\n}\n\n.ovw-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.ovw-chip svg {\n  color: #94a3b8;\n}\n\n.ovw-bullet {\n  color: #cbd5e1;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.ovw-amount {\n  color: #1e293b;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.ovw-redemption {\n  color: #0284c7;\n  font-weight: 600;\n}\n\n.ovw-card__bar,\n.ovw-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n}\n\n.ovw-card__bar {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ovw-card__head .ovw-pill {\n  flex-shrink: 0;\n  align-self: flex-start;\n  white-space: nowrap;\n}\n\n.ovw-card h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.ovw-card p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.ovw-search {\n  min-width: 180px;\n  padding: 0 12px;\n}\n\n.ovw-table-wrap {\n  overflow-x: auto;\n}\n\n.ovw-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.ovw-table th {\n  padding: 10px 16px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  text-align: start;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ovw-table td {\n  padding: 14px 16px;\n  font-size: 13px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ovw-table th.is-end,\n.ovw-table td.is-end {\n  text-align: end;\n}\n\n.ovw-name {\n  font-weight: 600;\n}\n\n.ovw-muted {\n  color: #64748b;\n  text-align: center;\n}\n\n.ovw-meter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 140px;\n}\n\n.ovw-meter__track,\n.ovw-mix__track {\n  flex: 1;\n  height: 8px;\n  border-radius: 99px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.ovw-meter__fill,\n.ovw-mix__track div {\n  height: 100%;\n  border-radius: 99px;\n  background: #0ea5e9;\n}\n\n.ovw-meter span,\n.ovw-mix__row strong {\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.ovw-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.ovw-pager div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ovw-pager button,\n.ovw-pager__page {\n  height: 32px;\n  min-width: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ovw-pager button:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.ovw-pager__page {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #0ea5e9;\n  border-color: #0ea5e9;\n  color: #ffffff;\n}\n\n.ovw-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.ovw-mix {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 20px 20px;\n}\n\n.ovw-mix__row {\n  display: grid;\n  grid-template-columns: minmax(90px, 140px) minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  color: #334155;\n  font-size: 13px;\n}\n\n.pkg-pie-card {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding: 4px 20px 20px;\n}\n\n.pkg-donut-wrap {\n  position: relative;\n  width: 196px;\n  height: 196px;\n  flex-shrink: 0;\n}\n\n.pkg-donut {\n  display: block;\n  transform: rotate(-90deg);\n}\n\n.pkg-donut-center {\n  position: absolute;\n  inset: 42px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  pointer-events: none;\n}\n\n.pkg-donut-center span {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.pkg-donut-center strong {\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n}\n\n.clinical-main:has(.ptn),\n.clinical-main__scroll:has(.ptn) {\n  background: #f1f5f9;\n}\n\n.ptn {\n  box-sizing: border-box;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 24px;\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.ptn * {\n  box-sizing: border-box;\n}\n\n.ptn-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.ptn-crumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.ptn-crumb .is-current {\n  color: #0f172a;\n}\n\n.ptn-header__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.ptn-header h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 30px;\n}\n\n.ptn-header p {\n  margin: 2px 0 0;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.ptn-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.ptn-switch a {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.ptn-switch a:hover {\n  color: #0f172a;\n}\n\n.ptn-switch a.is-active {\n  background: #e0f2fe;\n  color: #0284c7;\n  font-weight: 600;\n}\n\n.ptn-switch__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #0284c7;\n}\n\n.ptn-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ptn-filters__start {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.ptn-range-wrap,\n.ptn-select-wrap,\n.ptn-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.ptn-range-wrap > svg,\n.ptn-select-wrap > svg:first-child,\n.ptn-search > svg {\n  position: absolute;\n  color: #64748b;\n  pointer-events: none;\n}\n\n.ptn-range-wrap > svg,\n.ptn-select-wrap > svg:first-child {\n  left: 12px;\n  z-index: 1;\n}\n\n.ptn-select-wrap > svg:last-child {\n  position: absolute;\n  right: 10px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.ptn-select,\n.ptn-export,\n.ptn-search input {\n  height: 36px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 13px;\n  font-family: inherit;\n  font-weight: 500;\n}\n\n.ptn-select {\n  min-width: 180px;\n  padding: 0 32px;\n  appearance: none;\n  cursor: pointer;\n}\n\n.ptn-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  cursor: pointer;\n}\n\n.ptn-export svg {\n  color: #64748b;\n}\n\n.ptn-export:hover,\n.ptn-select:hover,\n.ptn-search input:hover {\n  background: #f8fafc;\n}\n\n.ptn-range.ant-picker {\n  height: 36px;\n  padding-inline-start: 34px;\n  border-radius: 8px;\n  border-color: #cbd5e1;\n}\n\n.ptn-range .ant-picker-input > input {\n  font-size: 13px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-range .ant-picker-suffix {\n  color: #94a3b8;\n}\n\n.ptn-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.ptn-kpi,\n.ptn-card {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n}\n\n.ptn-kpi {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 16px;\n}\n\n.ptn-kpi__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  margin-bottom: 2px;\n}\n\n.ptn-kpi__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background: #e0f2fe;\n  color: #0284c7;\n}\n\n.ptn-kpi__label {\n  color: #64748b;\n  font-family: 'Public Sans', 'Inter', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ptn-kpi strong {\n  color: #0f172a;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 30px;\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-kpi p,\n.ptn-card p {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.ptn-kpi p {\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-split {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(260px, 1fr);\n  gap: 24px;\n}\n\n.ptn-card {\n  min-width: 0;\n  padding: 20px;\n}\n\n.ptn-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.ptn-card h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  line-height: 22px;\n}\n\n.ptn-search > svg {\n  left: 10px;\n}\n\n.ptn-search input {\n  width: 192px;\n  padding: 0 12px 0 32px;\n}\n\n.ptn-search input:focus,\n.ptn-select:focus,\n.ptn-range.ant-picker-focused {\n  border-color: #0ea5e9;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n}\n\n.ptn-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.ptn-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.ptn-table th {\n  padding: 10px 14px;\n  background: #f8fafc;\n  color: #64748b;\n  font-family: 'Public Sans', 'Inter', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ptn-table td {\n  padding: 14px;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 13px;\n}\n\n.ptn-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.ptn-table tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.ptn-table th.is-end,\n.ptn-table td.is-end {\n  text-align: end;\n}\n\n.ptn-name {\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.ptn-num,\n.ptn-money {\n  color: #334155;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-money {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.ptn-money.is-neg {\n  color: #dc2626;\n}\n\n.ptn-empty {\n  color: #64748b;\n  text-align: center;\n}\n\n.ptn-birthdays {\n  display: flex;\n  flex-direction: column;\n}\n\n.ptn-birthdays > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.ptn-birthdays > div:first-child {\n  padding-top: 0;\n}\n\n.ptn-birthdays > div:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.ptn-birthdays strong {\n  display: block;\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.ptn-birthdays em {\n  display: block;\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 12px;\n  font-style: normal;\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-birthdays b {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.ptn-loading {\n  min-height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n}\n\n@media (max-width: 1100px) {\n  .ptn-header__top,\n  .ptn-kpis,\n  .ptn-split {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ptn-kpis {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .ptn-switch {\n    align-self: flex-start;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 720px) {\n  .ptn {\n    padding: 16px;\n  }\n\n  .ptn-kpis,\n  .ptn-card__head,\n  .ptn-filters {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ptn-search input,\n  .ptn-select {\n    width: 100%;\n  }\n}\n\n.pkg-pie-empty {\n  padding: 4px 20px 20px;\n}\n\n.pkg-pie-legend {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pkg-pie-legend > div {\n  display: grid;\n  grid-template-columns: 12px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pkg-pie-legend > div:last-child {\n  border-bottom: 0;\n}\n\n.pkg-pie-legend i {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.pkg-pie-legend span {\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pkg-pie-legend strong {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.pkg-pie-legend em {\n  color: #64748b;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n@media (max-width: 720px) {\n  .pkg-pie-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.ovw-loading {\n  min-height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n}\n\n@media (max-width: 1100px) {\n  .ovw-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ovw-controls {\n    justify-content: flex-start;\n  }\n\n  .ovw-kpis,\n  .ovw-split {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .ovw-kpis,\n  .ovw-split,\n  .ovw-card__bar {\n    grid-template-columns: 1fr;\n    flex-direction: column;\n  }\n}\n\n.clinical-main:has(.wrk),\n.clinical-main__scroll:has(.wrk) {\n  background: #f8fafc;\n}\n\n.wrk {\n  box-sizing: border-box;\n  min-height: 100%;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.wrk-body {\n  padding: 24px;\n}\n\n.wrk * {\n  box-sizing: border-box;\n}\n\n.wrk-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wrk-header__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.wrk-header h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n\n.wrk-header p,\n.wrk-card p,\n.wrk-table-card__head p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.wrk-switch {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f1f5f9;\n}\n\n.wrk-switch a {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 6px;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.wrk-switch a.is-active {\n  background: #ffffff;\n  color: #0284c7;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.wrk-switch__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #0ea5e9;\n}\n\n.wrk-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 4px;\n}\n\n.wrk-filters__start {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.wrk-range-wrap,\n.wrk-select-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.wrk-range-wrap > svg,\n.wrk-select-wrap > svg {\n  position: absolute;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.wrk-range-wrap > svg {\n  left: 10px;\n  z-index: 1;\n}\n\n.wrk-select-wrap > svg {\n  right: 10px;\n}\n\n.wrk-select,\n.wrk-export,\n.wrk-search {\n  height: 36px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.wrk-table-tools .wrk-select {\n  padding: 0 10px;\n}\n\n.wrk-select-wrap .wrk-select {\n  min-width: 220px;\n  padding: 0 32px 0 12px;\n  appearance: none;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  cursor: pointer;\n}\n\n.wrk-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  color: #334155;\n  font-weight: 500;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  cursor: pointer;\n}\n\n.wrk-export svg {\n  color: #64748b;\n}\n\n.wrk-range.ant-picker {\n  height: 36px;\n  padding-inline-start: 32px;\n  border-radius: 8px;\n  border-color: #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.wrk-range .ant-picker-input > input {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.wrk-range .ant-picker-suffix {\n  color: #94a3b8;\n}\n\n.wrk-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.wrk-kpi,\n.wrk-card,\n.wrk-table-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.wrk-kpi {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 148px;\n  padding: 20px;\n}\n\n.wrk-kpi__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wrk-kpi p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.wrk-kpi strong {\n  display: block;\n  margin-top: 4px;\n  font-size: 26px;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n}\n\n.wrk-kpi strong span {\n  color: #94a3b8;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.wrk-kpi__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n}\n\n.wrk-kpi__icon.is-sky {\n  background: #f0f9ff;\n  color: #0ea5e9;\n  border-color: #e0f2fe;\n}\n\n.wrk-kpi__icon.is-green {\n  background: #ecfdf5;\n  color: #059669;\n  border-color: #d1fae5;\n}\n\n.wrk-kpi__icon.is-indigo {\n  background: #eef2ff;\n  color: #4f46e5;\n  border-color: #e0e7ff;\n}\n\n.wrk-kpi__icon.is-amber {\n  background: #fffbeb;\n  color: #d97706;\n  border-color: #fef3c7;\n}\n\n.wrk-kpi__foot {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.wrk-kpi__foot .is-up {\n  color: #047857;\n}\n\n.wrk-kpi__foot .is-down {\n  color: #be123c;\n}\n\n.wrk-split {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.wrk-card,\n.wrk-table-card__head {\n  padding: 20px;\n}\n\n.wrk-card__head,\n.wrk-table-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.wrk-card h2,\n.wrk-table-card h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.wrk-legend {\n  display: flex;\n  gap: 12px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.wrk-legend span,\n.wrk-legend i {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wrk-legend i,\n.wrk-bar__pair span {\n  width: 10px;\n  border-radius: 2px;\n}\n\n.wrk-legend i {\n  height: 10px;\n}\n\n.wrk-legend i.is-scheduled,\n.wrk-bar__pair .is-scheduled {\n  background: #e2e8f0;\n}\n\n.wrk-legend i.is-completed,\n.wrk-bar__pair .is-completed {\n  background: #0ea5e9;\n}\n\n.wrk-bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  height: 220px;\n  margin-top: 20px;\n  padding-top: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wrk-bar {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 0;\n  height: 100%;\n}\n\n.wrk-bar__ratio {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-bottom: 6px;\n  font-size: 10px;\n  font-style: normal;\n  font-variant-numeric: tabular-nums;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.wrk-bar__ratio .is-completed {\n  color: #0284c7;\n  font-weight: 600;\n}\n\n.wrk-bar__ratio .is-scheduled {\n  color: #64748b;\n}\n\n.wrk-bar__pair {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  height: 160px;\n}\n\n.wrk-bar__pair span {\n  width: 16px;\n  min-height: 0;\n  border-radius: 3px 3px 0 0;\n}\n\n.wrk-bar strong,\n.wrk-bar em {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wrk-bar strong {\n  margin-top: 8px;\n  font-size: 11px;\n}\n\n.wrk-bar em {\n  color: #94a3b8;\n  font-size: 10px;\n  font-style: normal;\n}\n\n.wrk-durations {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 18px;\n}\n\n.wrk-duration__label {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.wrk-duration__track {\n  height: 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.wrk-duration__track span {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: #0ea5e9;\n}\n\n.wrk-search {\n  width: 220px;\n  padding: 0 12px;\n}\n\n.wrk-table-tools {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.wrk-chart-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 16px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.wrk-chart-foot span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.wrk-chart-foot svg {\n  color: #059669;\n}\n\n.wrk-table-card__head {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wrk-table-wrap {\n  overflow-x: auto;\n}\n\n.wrk-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.wrk-table th {\n  padding: 10px 16px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.wrk-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.wrk-table th.is-end,\n.wrk-table td.is-end {\n  text-align: end;\n}\n\n.wrk-doctor,\n.wrk-spec {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.wrk-doctor {\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.wrk-doctor > span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  border: 1px solid #bae6fd;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.wrk-doctor strong,\n.wrk-spec strong {\n  font-weight: 600;\n}\n\n.wrk-clinics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.wrk-clinics span {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f0f9ff;\n  color: #0369a1;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.wrk-clinics i {\n  color: #0f172a;\n  font-style: normal;\n  font-variant-numeric: tabular-nums;\n}\n\n.wrk-doctor em,\n.wrk-spec em,\n.wrk-of {\n  color: #94a3b8;\n  font-size: 11px;\n  font-style: normal;\n}\n\n.wrk-count {\n  color: #047857;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.wrk-load {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wrk-load div {\n  flex: 1;\n  height: 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  overflow: hidden;\n}\n\n.wrk-load span {\n  display: block;\n  height: 100%;\n  background: #10b981;\n}\n\n.wrk-load em {\n  width: 40px;\n  font-style: normal;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: end;\n}\n\n.wrk-table a {\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.wrk-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.wrk-pager div {\n  display: flex;\n  gap: 8px;\n}\n\n.wrk-pager button {\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.wrk-pager button:disabled {\n  color: #94a3b8;\n  cursor: default;\n}\n\n.wrk-insights {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.wrk-insight {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.wrk-insight__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.wrk-insight h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.wrk-insight__head p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.wrk-logged {\n  padding: 2px 8px;\n  border: 1px solid #a7f3d0;\n  border-radius: 4px;\n  background: #ecfdf5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.wrk-insight__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e0f2fe;\n  border-radius: 999px;\n  background: #f0f9ff;\n  color: #0ea5e9;\n}\n\n.wrk-mix {\n  margin-top: 20px;\n}\n\n.wrk-mix__bar {\n  display: flex;\n  height: 12px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #f1f5f9;\n}\n\n.wrk-mix__bar span,\n.wrk-mix__cells i {\n  display: block;\n}\n\n.wrk-mix__bar .is-finished,\n.wrk-mix__cells .is-finished {\n  background: #0ea5e9;\n}\n\n.wrk-mix__bar .is-open,\n.wrk-mix__cells .is-open {\n  background: #6366f1;\n}\n\n.wrk-mix__bar .is-missed,\n.wrk-mix__cells .is-missed {\n  background: #10b981;\n}\n\n.wrk-mix__cells {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.wrk-mix__cells > div {\n  padding: 10px;\n  border: 1px solid #f1f5f9;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.wrk-mix__cells span {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.wrk-mix__cells i {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.wrk-mix__cells strong {\n  display: block;\n  margin-top: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 14px;\n}\n\n.wrk-mix__cells em {\n  color: #94a3b8;\n  font-size: 10px;\n  font-style: normal;\n}\n\n.wrk-timing {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin: 16px 0;\n}\n\n.wrk-timing > div {\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  text-align: center;\n}\n\n.wrk-timing span {\n  display: block;\n  color: #94a3b8;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.wrk-timing strong {\n  display: block;\n  margin-top: 2px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 17px;\n}\n\n.wrk-timing em {\n  color: #059669;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.wrk-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wrk-notes > div {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px;\n  border: 1px solid #f1f5f9;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.wrk-notes svg {\n  flex: none;\n  color: #0ea5e9;\n}\n\n.wrk-notes p {\n  margin: 0;\n  color: #1e293b;\n  font-size: 12px;\n}\n\n.wrk-insight__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.wrk-insight__foot a {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.wrk-insight__foot a svg {\n  transform: rotate(-90deg);\n}\n\n.wrk-empty,\n.wrk-loading {\n  padding: 28px 16px;\n  color: #64748b;\n  text-align: center;\n}\n\n@media (max-width: 1100px) {\n  .wrk-kpis,\n  .wrk-split,\n  .wrk-insights,\n  .wrk-header__top {\n    grid-template-columns: 1fr 1fr;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 720px) {\n  .wrk-kpis,\n  .wrk-split,\n  .wrk-insights,\n  .wrk-mix__cells,\n  .wrk-timing {\n    grid-template-columns: 1fr;\n  }\n}\n\n.yld-kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.yld-kpi,\n.yld-card,\n.yld-table-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.yld-kpi {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 148px;\n  padding: 20px;\n}\n\n.yld-kpi__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.yld-kpi p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.yld-kpi strong {\n  display: block;\n  margin-top: 4px;\n  font-size: 22px;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n.yld-kpi__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n}\n\n.yld-kpi__icon.is-sky {\n  background: #f0f9ff;\n  color: #0ea5e9;\n  border-color: #e0f2fe;\n}\n\n.yld-kpi__icon.is-indigo {\n  background: #eef2ff;\n  color: #4f46e5;\n  border-color: #e0e7ff;\n}\n\n.yld-kpi__icon.is-green {\n  background: #ecfdf5;\n  color: #059669;\n  border-color: #d1fae5;\n}\n\n.yld-kpi__icon.is-amber {\n  background: #fffbeb;\n  color: #d97706;\n  border-color: #fef3c7;\n}\n\n.yld-kpi__foot {\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.yld-kpi__foot .is-up,\n.yld-kpi__foot .is-down {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.yld-kpi__foot .is-up {\n  color: #047857;\n}\n\n.yld-kpi__foot .is-down {\n  color: #be123c;\n}\n\n.yld-split {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 16px;\n}\n\n.yld-card,\n.yld-table-card__head {\n  padding: 20px;\n}\n\n.yld-card h2,\n.yld-table-card h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.yld-card p,\n.yld-table-card__head p {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.yld-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin-top: 14px;\n  color: #475569;\n  font-size: 11px;\n}\n\n.yld-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.yld-legend i,\n.yld-share__label i {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.yld-legend .is-line::before {\n  content: '';\n  width: 14px;\n  height: 2px;\n  background: #0f172a;\n}\n\n.yld-plot {\n  position: relative;\n  margin-top: 12px;\n  margin-bottom: 28px;\n}\n\n.yld-plot .yld-stack {\n  position: relative;\n  height: 170px;\n  margin-top: 0;\n  border-bottom: 0;\n}\n\n.yld-plot .yld-stack__col {\n  position: relative;\n  height: 170px;\n}\n\n.yld-plot .yld-stack__col strong {\n  position: absolute;\n  bottom: -22px;\n  margin: 0;\n}\n\n.yld-line {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 170px;\n  width: 100%;\n  pointer-events: none;\n}\n\n.yld-chart-foot {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.yld-share__label span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.yld-lead {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.yld-lead i {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.yld-bottom {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 16px;\n}\n\n.yld-machines {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.yld-machines > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #f1f5f9;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.yld-machines strong,\n.yld-machines em {\n  display: block;\n}\n\n.yld-machines em {\n  color: #94a3b8;\n  font-size: 11px;\n  font-style: normal;\n}\n\n.yld-machines > div > span {\n  color: #0284c7;\n  font-size: 16px;\n  font-weight: 700;\n  text-align: end;\n}\n\n.yld-machines small {\n  display: block;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.yld-stack {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  height: 220px;\n  margin-top: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.yld-stack__col {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 0;\n  height: 100%;\n}\n\n.yld-stack__bar {\n  display: flex;\n  flex-direction: column-reverse;\n  width: 36px;\n  height: 170px;\n}\n\n.yld-stack__bar span {\n  display: block;\n  width: 100%;\n  min-height: 2px;\n}\n\n.yld-stack__col strong {\n  margin: 8px 0;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.yld-shares {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-top: 16px;\n}\n\n.yld-share__label {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.yld-share__track,\n.yld-orders__bar {\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #f1f5f9;\n}\n\n.yld-share__track span,\n.yld-orders__bar span {\n  display: block;\n  height: 100%;\n}\n\n.yld-orders__bar {\n  display: flex;\n  height: 12px;\n  margin-top: 16px;\n}\n\n.yld-orders__cells {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.yld-orders__cells > div {\n  padding: 10px;\n  border: 1px solid #f1f5f9;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.yld-orders__cells span {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #475569;\n  font-size: 11px;\n}\n\n.yld-orders__cells strong {\n  display: block;\n  margin-top: 4px;\n  font-size: 14px;\n}\n\n.yld-orders__cells em {\n  color: #94a3b8;\n  font-size: 10px;\n  font-style: normal;\n}\n\n.yld-table-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.yld-search {\n  width: 220px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: inherit;\n}\n\n.yld-table-wrap {\n  overflow-x: auto;\n}\n\n.yld-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.yld-table th {\n  padding: 10px 16px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.yld-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n\n.yld-table tfoot td {\n  background: #f8fafc;\n  font-weight: 700;\n}\n\n.yld-table th.is-end,\n.yld-table td.is-end {\n  text-align: end;\n}\n\n.yld-name {\n  font-weight: 600;\n}\n\n.yld-meter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.yld-meter div {\n  flex: 1;\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #f1f5f9;\n}\n\n.yld-meter span {\n  display: block;\n  height: 100%;\n  background: #0ea5e9;\n}\n\n.yld-meter span.is-green {\n  background: #10b981;\n}\n\n.yld-meter em {\n  width: 48px;\n  font-style: normal;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: end;\n}\n\n.yld-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.yld-pager div {\n  display: flex;\n  gap: 8px;\n}\n\n.yld-pager button {\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.yld-pager button:disabled {\n  color: #94a3b8;\n  cursor: default;\n}\n\n.yld-empty,\n.yld-loading {\n  padding: 28px 16px;\n  color: #64748b;\n  text-align: center;\n}\n\n@media (max-width: 1100px) {\n  .yld-kpis,\n  .yld-split,\n  .yld-bottom {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .yld-kpis,\n  .yld-split,\n  .yld-bottom {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
